module.exports = __webpack_public_path__ + "static/media/Sass.9dc413f7.jpg";